module.exports = __webpack_public_path__ + "media/images/front/brands/avant_garde/card-91569c5a0148890bbbcec234d9e14875.webp";